import Alert from '@material-ui/lab/Alert';
import GSTabs2 from "../../../../ambassador-docs/docs/pre-release/tutorials/gs-tabs2";
import * as React from 'react';
export default {
  Alert,
  GSTabs2,
  React
};